export const getCurrencySymbol = (currency: string): string => {
  const mapper: { [key: string]: string } = {
    "USD": "$",
    "EUR": "€",
    "GBP": "£",
    "DKK": "Dkr ",
    "SEK": "SKr ",
    "NOK": "Nkr ",
    "AUD": "A$",
  }

  const key = currency.toUpperCase();
  return mapper[key] || currency;
};

export const convertStringToNumber = (string: string) => {
  return Number(string.replace(/[^0-9.]+/g, ''));
};

export const convertToPrice = (value: string, currencyPrefix?: boolean, currency = 'USD', locale = 'en-US', ) => {
  const number = convertStringToNumber(value);
  const prefix = currencyPrefix ? getCurrencySymbol(currency) : '';

  const formattedResult = new Intl.NumberFormat(locale, {
    currency,
    minimumFractionDigits: 0
  }).format(number)

  return `${prefix}${formattedResult}`;
};

export const toValidChar = <T>(char: T) => {
  const str = String(char);
  return str.length === 1 && /\S/.test(str) ? str : '';
}

export const asArray = <T>(ob: T): T[] | T => (!ob ? [] : Array.isArray(ob) ? ob : [ob]);
export const definedValue = <T>(value: T | undefined | null, defaultValue: T): T => value ?? defaultValue;
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const nil = () => {}

// the own nature of this function is one of the exceptions where we can use `any` type 
// since we expressly want to allow any function signature
export function debounceAsyncFn<T extends (...args: any[]) => any>(
  func: T,
  delay: number
): (...args: Parameters<T>) => Promise<ReturnType<T>> {
  let timer: ReturnType<typeof setTimeout>;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>): Promise<ReturnType<T>> {
    return new Promise((resolve, reject) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        Promise.resolve(func.apply(this, args)).then(resolve).catch(reject);
      }, delay);
    });
  };
}